import { useState } from "react";

import type { VariantPage } from "@/lib/api/formatting/rorosTweed/productPage";

import UI from "./UI";

type Props = NonNullable<VariantPage["relatedSeries"]>[number];
const SeriesCard = (props: Props) => {
  const [hovering, setHovering] = useState(false);
  const hover = () => setHovering(true);
  const unhover = () => setHovering(false);
  return <UI {...{ ...props, hover, unhover, hovering }} />;
};

export default SeriesCard;
